import SabalPriceSheetsMappingsActivity from './PriceSheetsMappingsActivity';

const SabalPriceSheetsMappingsArchived = ({ event }: { event: any }) => {
  return <SabalPriceSheetsMappingsActivity event={event} label="Archived" />;
};

export default SabalPriceSheetsMappingsArchived;
